import { createOptionCategory, deleteOptionCategory } from '../../apis/backend'
import { ERROR_DUPLICATION, ERROR_SYNCHRONIZATION_WITH_SHOP, ERROR_UPDATE_PRODUCT_OPTION } from '../../constants'
import { sendCloudWatchAlert } from '../../utils/applicationError'
import { keyGenerator, isStringNotNull } from '../../utils/tools'
import { getShopsToSynchronise } from '../../utils/shopUtils'
import { setCopyKey } from '../../utils/product'
import _ from 'lodash'

export const handleClose = component => {
  component.setState({
    createCategorie: false,
    updateCategorie: false,
    removeCategorie: false,
    showAddCategoryModal: false,
    selectedShops: {}
  });
};

export const deleteCategorie = async (component) => {
  const { categorieRemoved, selectedShops, synchronize } = component.state;
  const { openErrorModal } = component.props;
  try {


    if (!synchronize || (synchronize && _.size(selectedShops) > 1)) {
      component.setState({ isLoading: true })
      handleClose(component);
      await deleteOptionCategory(categorieRemoved, synchronize, selectedShops);
      await component.setState({
        name: '',
        items: {},
        title: '',
        categorieRemoved: '',
        isLoading: false,
        showModal: false,
        selectedShops: {}
      });
    }
    else { openErrorModal(ERROR_SYNCHRONIZATION_WITH_SHOP); component.setState({ isLoading: false }) };
  } catch (e) {
    openErrorModal(ERROR_UPDATE_PRODUCT_OPTION);
    handleClose(component);
    await component.setState({
      name: '',
      items: {},
      title: '',
      categorieRemoved: '',
      isLoading: false,
      showModal: false
    });
    sendCloudWatchAlert(`Error when deleting category ${e}`);
  }
};

export const handleRemoveCategorie = (key, component) => {
  component.setState({ removeCategorie: true, categorieRemoved: key });
  const { showModal, categories = {}, shopId, shops, nbShops } = component.props;
  const { name = '' } = categories[key];
  const nbShopsToSync = _.size(getShopsToSynchronise())
  const modalData = {
    color: 'danger',
    title: `Êtes-vous sûr(e) de vouloir supprimer ${name} ?`,
    message: 'Toutes les options associées seront elles aussi supprimées !',
    showCancelBtn: true,
    checkboxes: nbShops > 1 && nbShopsToSync > 1 ?
      [{
        text: "Supprimer cette liste d'options sur un ou plusieurs magasins",
        onChange: checked => {
          component.setState({ synchronize: checked });
        }
      }] : [],
    btnColor: 'danger',
    onClick: () => {
      component.state.synchronize && nbShops > 1 && nbShopsToSync > 1 ?
        component.setState({
          selectedShops: { [shopId]: shops[shopId] },
          showModal: true,
          categoryKey: key
        }) :
        deleteCategorie(component);
      if (!component.state.synchronize) {
        component.setState({ synchronize: false, showModal: false });
      }

      showModal(null);
    },
    btnTxt: 'Supprimer'
  };
  showModal(modalData);
};
export const handleDuplicateCategorie = async (category, component) => {
  const { openErrorModal } = component.props;
  const key = setCopyKey(keyGenerator('OPTION'))
  category.key = key;
  for (let key in category.items) {

    if (category.items.hasOwnProperty(key)) {
      const newKey = keyGenerator('ITEM');
      category.items[key].key = newKey;
      category.items[newKey] = category.items[key];
      delete category.items[key];
    }
  }
  try {
    await createOptionCategory(category);
  } catch (error) {
    sendCloudWatchAlert(`Error updating product option  ${error}`);
    openErrorModal(ERROR_DUPLICATION);
  }
};
export const handleModifyCategorie = (key, component) => {
  const { categories = {} } = component.props;
  const categoryToRender = {
    ...categories[key],
    max: categories[key].max,
    key,
    multiple: categories[key].multiple
  };
  component.setState({
    updateCategorie: true,
    category: categoryToRender,
    showAddCategoryModal: true
  });
};

export const closeModal = component => {
  component.setState({ showAddCategoryModal: false, createCategorie: false, synchronize: false, selectedShops: {} });
};
export const handleChangeExpend = (event, expanded, panel, component) => {
  const { target = {} } = event;
  const { localName = {} } = target;
  const balise = localName;
  if (balise !== 'path' && balise !== 'svg') {
    component.setState({
      expanded: expanded ? panel : false
    });
  }
};
export const handleSearchChange = async (e, component) => {
  await component.setState({ searchTerm: e.target.value });
  getCategories(component);
};

export const getCategories = (component) => {
  const { categories = {} } = component.props;
  const clonedCategories = _.cloneDeep(categories);
  const searchTerm = component.state.searchTerm?.toLowerCase();

  if (!isStringNotNull(searchTerm)) {
    return clonedCategories;
  }

  return _.pickBy(clonedCategories, (category) => {
    const isCategoryMatch =
      category?.name?.toLowerCase().includes(searchTerm) ||
      category?.key?.toLowerCase().includes(searchTerm);

    if (isCategoryMatch) {
      return true;
    }
    const filteredItems = _.pickBy(category?.items, (item) =>
      item?.name?.toLowerCase().includes(searchTerm)
    );

    if (_.size(filteredItems) > 0) {
      category.items = filteredItems;
      return true;
    }

    return false;
  });
};
export const getDependencies = (items, parentData, categoryKey) => {
  const dependencies = [];
  _.forEach(parentData, (parent) => {
    _.forEach(items(parent), (item) => {
      const itemCategories = item.categories ? item.categories.split(',') : [];
      const itemSubCategories = item.subcategories ? item.subcategories.split(',') : [];

      if (itemCategories.includes(categoryKey) || itemSubCategories.includes(categoryKey)) {
        dependencies.push({
          name: item.name,
          key: item.key,
          parentName: parent.name,
          parentKey: parent.key,
        });
      }
    });
  });

  return dependencies;
};
export const groupDependencies = (items, parentData, categoryKey) => {
  const grouped = {};
  const dependencies = getDependencies(items, parentData, categoryKey);
  _.forEach(dependencies, (dependency) => {
    if (!grouped[dependency.parentKey]) {
      grouped[dependency.parentKey] = {
        parentName: dependency.parentName,
        parentKey: dependency.parentKey,
        items: [],
      };
    }
    grouped[dependency.parentKey].items.push({
      name: dependency.name,
      key: dependency.key,
    });
  });
  const groupedValues = _.values(grouped);
  const sortedGroupedValues = _.sortBy(groupedValues, 'parentName');

  return sortedGroupedValues;
};

